import React from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'markdown-to-jsx';

import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

import { useGetAboutContent } from '@lumirental/lumi-web-shared/lib/tanStackQuery/about.queries';

import BreadCrumb from '@/components/BreadCrumb';
import PageNotFoundContainer from '@/containers/PageNotFoundContainer';

import styles from '@/containers/TermsContainer/TermsContainer.style';

const useStyles = makeStyles()(styles);

export default function TermsContainer() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  // read props for ssr
  const { aboutContent, isError, isFetched } = useGetAboutContent();

  if (isError) {
    return <PageNotFoundContainer />;
  }

  return (
    <Container maxWidth="lg">
      <div className={classes.contentWrapper}>
        <BreadCrumb currentPage={t('terms_and_conditions_web')} />
        <div className={classes.titleWrapper}>
          <Typography variant="h2" className={classes.title}>
            {t('terms_and_conditions_web')}
          </Typography>
        </div>
        {isFetched && (
          <Card className={classes.cardWrapper}>
            <Markdown>{aboutContent?.termsCondition}</Markdown>
          </Card>
        )}
      </div>
    </Container>
  );
}
